import {
  type RouteObject,
} from "react-router";
import WordTemplateForListViewDetailApp from "WordTemplateForListView/detail/app";
import WordTemplateForListListApp from "WordTemplateForListView/list/app";
import WordTemplateForListViewNewApp from "WordTemplateForListView/new/app";

declare let viewModel: any;

export const wordTemplateForListViewRoute: RouteObject = {
  path: "wordtemplateforlistview",
  children: [{
    path : ":mainArea",
    loader: () => viewModel,
    Component: WordTemplateForListListApp,
  }, {
    path: "detail/:key",
    loader: () => viewModel,
    Component: WordTemplateForListViewDetailApp,
  }, {
    path: ":mainArea/new",
    loader: () => viewModel,
    Component: WordTemplateForListViewNewApp,
  }]
};